import React from 'react'
import "./Crew.css";
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';

function Crew() {
    return (
        <div className="crew">
            <img src="https://cdn2.unrealengine.com/18br-subs-firstshadows2-web-desktop-1920x1080-c2f1392b30b1.jpg" alt="" />
            <Fade delay={2000}>
                <div className="crew_img">
                    <img src="https://cdn2.unrealengine.com/en-subscriptions-fn-crew-png-wordmark-2200x1400-582022337.png" alt="" />
                </div>
            </Fade>

            <Bounce right duration={2000}>

                <div className="crew_title">
                    <p>
                        THE ULTIMATE FORTNITE OFFER
                    </p>
                </div>
            </Bounce>

            <Bounce right delay={1000}>
                <div className="crew_des">
                    <p>THE BEST WAY TO MAXIMIZE YOUR FORTNITE EXPERIENCE. JOINING THE FORTNITE CREW GETS MEMBERS EVERYTHING BELOW FOR ONLY ₹998.00 EACH MONTH.</p>
                </div>
            </Bounce>

            <Fade delay={2000}>
                <button className="crew_btn">
                    <p>JOIN NOW</p>
                </button>
            </Fade>

            <Fade right delay={1000} >
                <div className="crew_title2">
                    <p>
                        SEE THIS MONTH'S BENEFITS
                    </p>
                </div>
            </Fade>

            <div className="crew_mid">

                <Bounce left duration={2000} >
                    <div className="crew_mid_img">
                        <img src="https://cdn2.unrealengine.com/battlepass-1920x1171-512732341.png" alt="" />
                    </div>
                </Bounce>
                <Bounce right duration={2000}>
                    <div className="crew_mid_des">
                        <p>BATTLE PASS INCLUDED FOR THE FULL SEASON</p>
                    </div>
                    <div className="crew_mid_des1">
                        <p>MEMBER OF THE FORTNITE CREW? CONGRATS, YOU HAVE FULL ACCESS TO THE CURRENT SEASONS’ BATTLE PASS, AND YOU’LL CONTINUE TO RECEIVE FUTURE BATTLE PASSES WITH YOUR SUBSCRIPTION. UNLOCK 100 AWESOME BATTLE PASS REWARDS JUST BY PLAYING FORTNITE.</p>
                    </div>
                </Bounce>
            </div>

            <div className="crew_mid_coins">
                <Fade left duration={1000}>

                    <div className="crew_mid_coins_left">
                        <img src="https://cdn2.unrealengine.com/vbucks-left-796x722-503453116.png" alt="" />
                    </div>
                </Fade>

                <Bounce bottom cascade duration={2000}>
                    <div className="crew_mid_des_sec">
                        <div className="crew_img_coins_title">
                            <p>1,000 BONUS V -BUCKS EVERY MONTH</p>
                        </div>

                        <div className="crew_img_coins_title2">
                            <p>EACH MONTH YOU’LL RECEIVE 1,000 V-BUCKS THAT YOU CAN PUT TOWARDS THE HOTTEST OUTFITS, EMOTES AND MORE. AND WITH THE INCLUDED BATTLE PASS, YOU’LL BE ABLE TO UNLOCK EVEN MORE V-BUCKS!</p>
                        </div>
                    </div>
                </Bounce>

                <Fade right duration={1000}>
                    <div className="crew_mid_coins_right">
                        <img src="https://cdn2.unrealengine.com/vbucks-right-796x722-503453124.png" alt="" />
                    </div>
                </Fade>
            </div>

            <div className="crew_mid_char">
                <Bounce left duration={2000} >

                    <div className="crew_mid_char_headings">
                        <div className="crew_mid_char_title">
                            <h1>
                                A NEW MONTHLY CREW PACK
                            </h1>
                        </div>
                        <div className="crew_mid_char_des1">
                            <p>THE CREW PACK IS AN EXCLUSIVE OUTFIT BUNDLE THAT’S YOURS TO KEEP, AND SPECIAL ITEMS ARE CURATED FOR THE PACK MONTHLY. EACH MONTH’S CREW PACK FEATURES AN EXCLUSIVE NEW OUTFIT PLUS AT LEAST ONE MATCHING ACCESSORY LIKE A GLIDER, PICKAXE, OR EMOTE.</p>
                        </div>
                        <div className="crew_mid_char_des1">
                            <p>OCTOBER'S PACK FEATURES CHAOS ORIGINS, THE SECOND OF "THE FIRST SHADOWS." ALONG WITH THE OUTFIT, WEAR HIS ESSENCE WITH THE SIPHON PACK BACK BLING, HARVEST WITH THE MUTAGEN MACE PICKAXE, AND MATCH HIS SUIT WITH THE WORLD DOMINATOR WRAP.</p>
                        </div>
                        <div className="crew_mid_char_des1">
                            <p>THE FIRST SHADOWS ARE AMONG THE ISLAND'S MOST SKILLED AGENTS. THE THIRD AND FINAL WILL MAKE HER ENTRANCE IN NOVEMBER’S CREW PACK. AS AN EXTRA, PLAYERS WHO’VE GATHERED ALL THREE OF THE FIRST SHADOWS WILL RECEIVE A BONUS STYLE FOR EACH.</p>
                        </div>
                    </div>
                </Bounce>

                <Bounce right duration={2000} >
                    <div className="crew_mid_coins_img">
                        <img src="https://cdn2.unrealengine.com/anonymouscharacterbundle-940x963-511731041.png" alt="" />
                    </div>
                </Bounce>
            </div>

            <div className="crew_mid_char2">

                <Bounce bottom duration={2000}>
                    <div className="crew_mid_char2_img">
                        <img src="https://clipart.info/images/ccovers/1547067511fortnite-battle-royale-character-png-112.png" alt="" />
                    </div>
                </Bounce>

                <Bounce bottom duration={2000}>
                    <div className="crew_mid_char2_headings">

                        <div className="crew_mid_char2_title">
                            <h1>ASSEMBLE THE FIRST SHADOWS</h1>
                        </div>

                        <div className="crew_mid_char2_des">
                            <p>
                                COMING TO FORTNITE CREW OVER THE NEXT THREE MONTHS (SEPT, OCT, NOV) ARE "THE FIRST SHADOWS," THREE UNLIKELY ALLIES UNITED BY A GENIUS WHO SAW THEIR POTENTIAL. AS AN EXTRA IN NOVEMBER, SUBSCRIBED PLAYERS WHO'VE OBTAINED ALL THREE OF THE FIRST SHADOWS WILL BE REWARDED A BONUS STYLE FOR EACH.
                            </p>
                        </div>

                    </div>
                </Bounce>
            </div>

            <div className="crew_mid_char3">
                <Bounce left duration={2000} >
                    <div className="crew_mid_char3_headers">
                        <div className="crew_mid_char3_title">
                            <h1>
                                COLLECT AN EVOLVING BACK BLING AND PICKAXE!

                            </h1>
                        </div>

                        <div className="crew_mid_char3_des">
                            <p>THE FORTNITE CREW LEGACY SET! THIS SET INCLUDES A BACK BLING AND UNLOCKABLE PICKAXE, EACH AN EVOLVING MEMENTO OF YOUR FORTNITE CREW MEMBERSHIP. FOR EVERY MONTH YOU’RE AN ACTIVE SUBSCRIBER, YOU’LL UNLOCK A NEW STAGE OF THE LEGACY SET FOR UP TO SIX TOTAL STAGES.</p>
                        </div>
                    </div>
                </Bounce>
                <Bounce right duration={2000} delay={1000} >
                    <div className="crew_mid_char3_img">
                        <img src="https://i.pinimg.com/originals/dc/82/9f/dc829f4806776a0e3d1061d69eb2d631.png" alt="" />
                    </div>
                </Bounce>
            </div>


            <div className="accordian">
                <h1 className="accordian__questions">FORTNITE CREW FAQS</h1>
                <Bounce bottom duration={3000}>

                    <div className="accordion" id="accordionExample">
                        <div className="background_color">
                            <h2 className="accordion-header" id="headingOne" >
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <h4 className="accordian_titles">
                                        HOW CAN I PURCHASE THE FORTNITE CREW SUBSCRIPTION?
                                    </h4>
                                </button>
                            </h2>
                        </div>
                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                The Fortnite Crew subscription can be purchased directly from the Item Shop or <strong>
                                    Battle Pass</strong>  purchase screen.
                            </div>
                        </div>
                    </div>
                </Bounce>
                <Bounce bottom duration={3000}>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                <h4 className="accordian_titles">
                                    WHAT’S IN A CREW PACK?
                                </h4>

                            </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                Monthly Crew Packs always contain a <strong>new Outfit </strong> along with at least one accessory. All items are exclusive to Fortnite Crew members.
                            </div>
                        </div>
                    </div>
                </Bounce>

                <Bounce bottom duration={3000}>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <h4 className="accordian_titles">
                                    CAN I STILL PURCHASE A BATTLE BUNDLE?
                                </h4>
                            </button>
                        </h2>
                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                The Battle Bundle has been replaced by a bundle of 25 levels, available for <strong> 1,850 V-Bucks.</strong> The offer is available to players at level 75 or lower at any time, once per season. This bundle can be packaged together when buying the standard Battle Pass by itself, or purchased after buying the standalone <strong>Battle Pass</strong>  or acquiring it as a member of Fortnite Crew.
                            </div>
                        </div>
                    </div>
                </Bounce>

                <Bounce bottom duration={3000}>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <h4 className="accordian_titles">
                                    ONCE I’M SUBSCRIBED, HOW DO I GET MY ITEMS EACH MONTH?
                                </h4>
                            </button>
                        </h2>
                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                Your Subscription is associated with the platform on which you purchased it (your “Primary Platform”) until it is cancelled and is not transferable. Be sure to choose the platform(e.g., Xbox, PlayStation, Switch)you purchase your Subscription on carefully. You’ll be able to access the items you receive from the Subscription across different platforms, but the V-Bucks you receive may not be redeemable on other platforms. You must log into your Primary Platform each monthly subscription period to access your <strong>Subscription </strong> Content.
                            </div>
                        </div>
                    </div>
                </Bounce>



            </div>

            <div className="crew_footer">
                <Fade duration={2000} delay={3000}>
                    <div className="crew_footer_des">
                        <p>RECURRING ₹998.00 SUBSCRIPTION FEE CHARGED MONTHLY UNTIL CANCELLED. YOU CAN CANCEL ANYTIME. SEE <strong> SUBSCRIPTION TERMS</strong> FOR COMPLETE DETAILS, INCLUDING HOW TO CANCEL.</p>
                    </div>
                </Fade>
            </div>
        </div >
    )
}

export default Crew
